import { ProcessDetailService } from './../services/process-detail.service';
import { ModalService } from './../services/modal.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AdminRouteModule } from './admin-route.module';
import { AdditionalAdminFeaturesRouteModule } from './additional-admin-features/additional-admin-features-route.module';

import { SortablejsModule } from 'ngx-sortablejs';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxSelectModule } from 'ngx-select-ex';
import { TreeviewModule } from 'ngx-treeview';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import {
  BsDatepickerModule,
  BsDatepickerConfig,
} from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { SaveFormService } from '../services/save-form.service';
import { QuestionService } from '../services/question.service';
import { ProcessService } from '../services/process.service';
import { ProcessParticipationService } from '../services/process.participation.service';

import { BusinessUnitFilterPipe } from '../pipes/business-unit.filter.pipe';

import { AdminComponent } from './admin.component';
import { QuestionListComponent } from './question-list/question-list.component';
import { QuestionFormsComponent } from './question-forms/question-forms-selector.component';
import { CheckboxRadioFormComponent } from './question-forms-builder/checkbox-radio-form/checkbox-radio-form.component';
import { MatrixFormComponent } from './question-forms-builder/matrix-form/matrix-form.component';
import { TextFormComponent } from './question-forms-builder/text-form/text-form.component';
import { QuestionFormsBuilderComponent } from './question-forms-builder/question-forms-builder.component';
import { ProcessesListComponent } from './processes-list/processes-list.component';
import { ProcessComponent } from './processes-list/process/process.component';
import { ProcessBuilderComponent } from './processes-list/process-builder/process-builder.component';
import { AdminSurveyListComponent } from './survey/admin-survey-list.component';
import { ReportsComponent } from './reports/reports.component';
import { CategoriesListComponent } from './question-list/categories-list/categories-list.component';
import { QuestionTextComponent } from './question-forms/question-text/question-text.component';
import { QuestionCheckboxRadioComponent } from './question-forms/question-checkbox-radio/question-checkbox-radio.component';
import { QuestionMatrixComponent } from './question-forms/question-matrix/question-matrix.component';
import { SurveyEditorComponent } from './survey-editor/survey-editor.component';
import { ProcessGeneralInfoComponent } from './processes-list/process-builder/process-general-info/process-general-info.component';
import { RespondentsSelectionComponent } from './processes-list/process-builder/respondents-selection/respondents-selection.component';
import { ProcessSettingsComponent } from './processes-list/process-builder/process-settings/process-settings.component';
import { NotificationsComponent } from './processes-list/process-builder/notifications/notifications.component';
import { RespondentEditListComponent } from './processes-list/process-builder/respondent-edit-list/respondent-edit-list.component';
import { RepeatableProcessComponent } from './processes-list/process-builder/repeatable-process/repeatable-process.component';
import { AppraiseeComponent } from './processes-list/process-builder/appraisee/appraisee.component';
import { DetailedProcessComponent } from './detailed-process/detailed-process.component';
import { AdditionalAdminFeaturesComponent } from './additional-admin-features/additional-admin-features.component';
import { FeedbackManageComponent } from './additional-admin-features/feedback-manage/feedback-manage.component';
import { FbtCommonModule } from '../common/common.module';
import { ReportingService } from '../services/reporting.service';
import { DetailedProcessAppraiseeComponent } from './detailed-process/detailed-process-appraisee/detailed-process-appraisee.component';
import { AppraiseeProvider } from '../common/providers/appraisee.provider';
import { ProcessListActionMenuComponent } from './processes-list/process-list-action-menu/process-list-action-menu.component';
import { ProcessReportSettingsComponent } from './processes-list/process-builder/process-report-settings/process-report-settings.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppraiseeInfoModuleComponent } from '../common/reporting/brief-report/appraisee-info-module/appraisee-info-module.component';
import { DetailedReportFaqComponent } from '../common/reporting/detailed-report/detailed-report-faq/detailed-report-faq.component';
import { TextQuestionsModuleComponent } from '../common/reporting/brief-report/text-questions-module/text-questions-module.component';
import { CategoriesComponent } from '../common/reporting/detailed-report/categories/categories.component';
import { CategoryQuestionComponent } from '../common/reporting/detailed-report/categories/category-question/category-question.component';
import { QuestionScaleComponent } from '../common/reporting/detailed-report/categories/category-question/question-scale/question-scale.component';
import { AppraiseeService } from '../services/appraisee.service';
import { ClipboardCopyService } from '../services/clibpboardCopy.service';
import { AssignHrForBusinessUnitComponent } from './additional-admin-features/assign-hr-for-business-unit/assign-hr-for-business-unit.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    showWeekNumbers: false,
    dateInputFormat: 'DD.MM.YYYY',
  });
}

defineLocale('en-gb', enGbLocale);

@NgModule({
  imports: [
    FbtCommonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AdminRouteModule,
    AdditionalAdminFeaturesRouteModule,
    NgxSelectModule,
    NgxPaginationModule,
    TreeviewModule.forRoot(),
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    SortablejsModule,
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  declarations: [
    QuestionListComponent,
    QuestionFormsComponent,
    AdminComponent,
    CheckboxRadioFormComponent,
    MatrixFormComponent,
    TextFormComponent,
    QuestionFormsBuilderComponent,
    AdminSurveyListComponent,
    ProcessesListComponent,
    ProcessComponent,
    ReportsComponent,
    CategoriesListComponent,
    QuestionTextComponent,
    QuestionCheckboxRadioComponent,
    QuestionMatrixComponent,
    SurveyEditorComponent,
    QuestionMatrixComponent,
    ProcessBuilderComponent,
    ProcessGeneralInfoComponent,
    RespondentsSelectionComponent,
    ProcessSettingsComponent,
    NotificationsComponent,
    RespondentEditListComponent,
    RepeatableProcessComponent,
    AppraiseeComponent,
    DetailedProcessComponent,
    AdditionalAdminFeaturesComponent,
    FeedbackManageComponent,
    DetailedProcessAppraiseeComponent,
    ProcessListActionMenuComponent,
    ProcessReportSettingsComponent,
    AssignHrForBusinessUnitComponent,
  ],
  exports: [],
  providers: [
    SaveFormService,
    QuestionService,
    ProcessService,
    ProcessParticipationService,
    ModalService,
    BusinessUnitFilterPipe,
    ProcessDetailService,
    ReportingService,
    AppraiseeProvider,
    AppraiseeService,
    { provide: BsDatepickerConfig, useFactory: getDatepickerConfig },
    ClipboardCopyService,
  ],
})
export class AdminModule {}
